/** Function for converting a csv to JSON
 * @params: csv (string)
 * @mandatory: yes
 * @desc: Function for converting a csv to JSON. Import using: import csvToJSON from '@/services/utils'
 */

export default function csvToJSON(csv) {
	var lines = csv.split('\n');
	var result = [];
	var headers = lines[0].split(',');

	for (var i = 1; i < lines.length; i++) {
		var obj = {};
		var currentline = lines[i].split(',');
		for (var j = 0; j < headers.length; j++) {
			obj[headers[j]] = decodeURI(encodeURI(currentline[j]));

		}

		result.push(obj);
	}
	
	return result;
}



// WEBPACK FOOTER //
// ./src/services/utils.js